/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Field_Goal_WordsInputs */

const en_us2_search_field_goal_words = /** @type {(inputs: Search_Field_Goal_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`goal target hypertrophy strength fat loss muscle`)
};

const pt_br2_search_field_goal_words = /** @type {(inputs: Search_Field_Goal_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`objetivo meta hipertrofia forca emagrecimento massa`)
};

const es_419_search_field_goal_words = /** @type {(inputs: Search_Field_Goal_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`objetivo meta hipertrofia fuerza perder grasa musculo`)
};

const pt_pt2_search_field_goal_words = /** @type {(inputs: Search_Field_Goal_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`objetivo meta hipertrofia forca emagrecimento massa musculo`)
};

const fr_fr2_search_field_goal_words = /** @type {(inputs: Search_Field_Goal_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`objectif but hypertrophie force perte de poids muscle masse`)
};

const de_de2_search_field_goal_words = /** @type {(inputs: Search_Field_Goal_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ziel hypertrophie kraft abnehmen fettabbau muskel muskelaufbau`)
};

const it_it2_search_field_goal_words = /** @type {(inputs: Search_Field_Goal_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`obiettivo traguardo ipertrofia forza dimagrimento massa muscolo`)
};

/**
* | output |
* | --- |
* | "goal target hypertrophy strength fat loss muscle" |
*
* @param {Search_Field_Goal_WordsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_field_goal_words = /** @type {((inputs?: Search_Field_Goal_WordsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Field_Goal_WordsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_field_goal_words(inputs)
	if (locale === "es-419") return es_419_search_field_goal_words(inputs)
	if (locale === "pt-PT") return pt_pt2_search_field_goal_words(inputs)
	if (locale === "fr-FR") return fr_fr2_search_field_goal_words(inputs)
	if (locale === "de-DE") return de_de2_search_field_goal_words(inputs)
	if (locale === "it-IT") return it_it2_search_field_goal_words(inputs)
	return en_us2_search_field_goal_words(inputs)
});
export { search_field_goal_words as "search.field_goal_words" }